import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/chrome.png'
import _imports_1 from '@/assets/chrome2.png'
import _imports_2 from '@/assets/firefox.png'


const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row align-items-baseline" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mx-auto text-center" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Google Chrome"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "chrome"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "chrome"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col mx-auto text-center" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Firefox"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "firefox"
    })
  ])
], -1)
const _hoisted_5 = { class: "btn-group float-end mt-3" }

import Layout from '@/components/Layout.vue';
import Navigation from '@/components/Navigation.vue';
import {useHasActiveTest} from "@/hooks/hastest.hook";
import {onBeforeMount} from "vue";
import {useTranslate} from "@/hooks/translate.hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'SetupView',
  setup(__props) {

const t = useTranslate()
const hasTest = useHasActiveTest()
onBeforeMount(() => hasTest())

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('page.setup.title')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('page.setup.text.scenarios.text')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_unref(t)('page.setup.text.scenarios.list.0')), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)('page.setup.text.scenarios.list.1')), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('page.setup.text.first')), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('page.setup.text.second')), 1),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_RouterLink, {
                to: "/setup/camera",
                class: "btn btn-sm btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('page.setup.start')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_RouterLink, {
                to: "/list",
                class: "btn btn-sm btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('page.setup.return')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})